import { Preferences } from "../../profile/objects/preferences";
import { DMC_PROVIDER_MODULE, DEFAULT_COLUMN } from "../constant/dmcProviderConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setDmcProviderPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: DMC_PROVIDER_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '-created_date',
    });
